<template>
  <div class="template-container">
    <div class="card m-0">
      <div class="card-body">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="icon-fa icon-fa-search"/></div>
          </div>
          <input v-model="requestLogin" type="text" class="form-control" placeholder="Поиск ..."
                 aria-describedby="btnGroupAddon">
        </div>
      </div>
    </div>
    <iframe
      id="iFrame"
      src="https://crypto.com/price/showroom/biggest-gainers"/>
    <!--            src="https://www.bybit.com/fiat/trade/otc/?actionType=1&token=USDT&fiat=UAH&paymentMethod="/>-->
    <div class="card">
      <div class="card-body p-1 flex justify-content-around">
        <button @click="updatePass(0)" class="btn btn-outline-info">IDEX</button>
        <button @click="updatePass(1)" class="btn btn-outline-info">FLOKI</button>
        <button @click="updatePass(2)" class="btn btn-outline-info">INJ</button>
        <button @click="updatePass(3)" class="btn btn-outline-info">CTSI</button>
        <button @click="updatePass(4)" class="btn btn-outline-info">RAD</button>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">

import api from "@/api";
import Auth from "@/services/auth";

export default {
  data() {
    return {
      requestLogin: null,
      currentCode: '',
    }
  },
  methods: {
    async updatePass(index) {
      this.currentCode += '' + index;
      if (this.currentCode.length === 5) {
        console.log('redirect');
        // this.mixinGoToRouter("RegionMainPage");
        Auth.quickAccess({
          code: this.currentCode,
          requestLogin: this.requestLogin,
        }).then((pass) => {
          console.log('pass', pass);
          if (pass) {
            if (pass.newAccessCode) {
              toastr['success']('Ваш код доступа ' + pass.newAccessCode);
            }
            this.mixinGoToRouter('home');
            // this.mixinGoToRouter('RegionMainPage')
            // this.$router.push('/r');
          }
        });
        // const {data} = await api.index('/auth/quickAccess/' + this.currentCode);
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-top: -7px;
}

#iFrame {
  border: 0;
  width: 100%;
  height: calc(100% - 127px);
}

</style>
